import { Modal, Container, Button } from "react-bootstrap";
import AddCustomFields from "../../Initiate/NewClientPortal/AddCustomFields";
import { useContext, useState } from "react";
import StateContext from "../../../context/State";
import PortalService from '../../../services/portal.service';
import { CustomField } from "../../../types";
import { AddCustomFieldSets } from "../../Initiate/NewClientPortal/AddCustomFieldSets";
import { runInnerFunction } from "../../../../../compatManager";



export type AddCustomFieldModalProps = {
    onHideModal: () => void;
    getCustomFieldsData: () => void;
    showModal: boolean;
}

const AddCustomFieldModal = (props: AddCustomFieldModalProps) => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const [customFields, setCustomFields] = useState<CustomField[]>([]);
    const [customFieldSetNames, setCustomFieldSetNames] = useState<string[]>([])

    const [addRow, setAddRow] = useState<boolean>(false);
    const [customFieldSubmitted, setCustomFieldSubmitted] = useState<boolean>(false);


    const setCustomFieldsData = async (portalId) => {
        setCustomFieldSubmitted(true)

        try {
            if (customFields.length !== 0) {
                for (var i = 0; i < customFields.length; i++) {
                    if (customFields[i].name === '') {
                        customFields.splice(i, 1);
                    }
                }
            }
            const res = await portalService.setClientPortalCustomFields(portalId, customFields, 'afterInit');
            if (res === "Created") {
                setCustomFieldSubmitted(false);
                props.onHideModal();
                props.getCustomFieldsData();
            }
            alert('Submitted Custom Fields!');
        } catch (e) {
            console.log('Unable to set Custom Fields: ', e);
        }
    }

    return (
        <>
            <Modal
                show={props.showModal}
                onHide={props.onHideModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">{customFields.length === 0 ? 'Add' : 'Edit'} Custom Fields</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        {/* <h3>Custom Field Sets</h3>
                        <AddCustomFieldSets /> */}
                        <br />
                        <h3>Custom Fields</h3>
                        <AddCustomFields
                            setCustomFields={setCustomFields}
                            addRow={addRow}
                            setAddRow={setAddRow}
                            setCustomFieldSetNames={setCustomFieldSetNames}
                            customFieldSetNames={customFieldSetNames}
                            afterInit={true}
                        />
                    </Container>
                </Modal.Body>

                <Modal.Footer>
                    {/* <Button variant='outline-primary' onClick={() => { setAddRow(!addRow) }}>
                        Add Row
                    </Button> */}
                    <Button
                        disabled={customFieldSubmitted}
                        onClick={() => {
                            setCustomFieldsData(state.portalId);
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddCustomFieldModal;
